import strFormatter from "../StrFormatter";
import formatWithKeywords from "../formatWithKeywords";

function RuleDetails({ unit }) {
    const themeClass = 'theme-' + unit.faction;

    return (
        <div className={`unit-details ${themeClass}`}>
            {/* Header with stats inside */}
            {unit.rules.length > 0 &&
                <header className="unit-header">
                    <div className="header-top">
                        <div className="header-left">
                            <h2>{unit.rules[0].name}</h2>
                        </div>
                    </div>
                    <div>
                        <p style={{ whiteSpace: "pre-line" }}>{strFormatter(unit.rules[0].description)}</p>
                    </div>
                </header>
            }

            {/* Detachments */}
            {unit.detachments?.length > 0 && (
                <section className="abilities">
                    <h3 className="unit-header">Detachments</h3>
                    <ul>
                        {unit.detachments.map((d, i) => (
                            <li key={i} style={{ whiteSpace: "pre-line" }}>
                                <strong>{d.name}: </strong> {strFormatter(d.description)}
                            </li>
                        ))}
                    </ul>
                </section>
            )}

        </div >
    );
}

export default RuleDetails;
